module.exports = __webpack_public_path__ + "static/media/Desktop_Skills_16.5165f0a7.png";